import React, { lazy, Suspense } from "react";
import { hydrate, render } from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from "./components/App";
import MainLayout from "./components/layout/MainLayout";
import { HelmetProvider } from "react-helmet-async";

// ✅ CSS GLOBAL ÚNICO (ESTE ES EL BUENO)
import "./index.css";

/* Rutas secundarias en chunks propios: menos JS inicial, mejor TTI/INP en home */
const About = lazy(() =>
  import(/* webpackChunkName: "page-about" */ "./components/page/about/About")
);
const Contact = lazy(() =>
  import(/* webpackChunkName: "page-contact" */ "./components/page/contact/Contact")
);
const Service = lazy(() =>
  import(/* webpackChunkName: "page-service" */ "./components/page/service/Service")
);
const GekkoAi = lazy(() =>
  import(/* webpackChunkName: "page-gekko-ai" */ "./components/page/gekko-ai/GekkoAi")
);
const HomePageTwo = lazy(() =>
  import(
    /* webpackChunkName: "page-home-alt" */ "./components/page/homepage2/HomePageTwo"
  )
);
const ErrorPage = lazy(() =>
  import(/* webpackChunkName: "page-error" */ "./components/page/error/ErrorPage")
);

function RouteFallback() {
  return (
    <div className="gk-route-fallback" role="status" aria-live="polite">
      <span className="gk-sr-only">Cargando…</span>
    </div>
  );
}

function Root() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={MainLayout} />
        <Route
          exact
          path="/index2"
          render={(props) => (
            <Suspense fallback={<RouteFallback />}>
              <HomePageTwo {...props} />
            </Suspense>
          )}
        />

        <Route
          render={() => (
            <Layout>
              <Suspense fallback={<RouteFallback />}>
                <Switch>
                  <Route exact path="/about" component={About} />
                  <Route exact path="/contact" component={Contact} />
                  <Route exact path="/service" component={Service} />
                  <Route exact path="/gekko-ai" component={GekkoAi} />
                  <Route component={ErrorPage} />
                </Switch>
              </Suspense>
            </Layout>
          )}
        />
      </Switch>
    </BrowserRouter>
  );
}

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <Root />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootEl.hasChildNodes()) {
  hydrate(app, rootEl);
} else {
  render(app, rootEl);
}
